import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pageview } from '../analytics/gtag';

const PAGE_TITLES = {
  '/upload': ' - Upload',
  '/scene': ' - Scene',
  '/captures': ' - Captures',
};

export default function usePageViews() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const normalizedPath = location.pathname.toLowerCase();
    const title = PAGE_TITLES[normalizedPath] || '';

    // Set browser tab title
    document.title = `Cinesplat${title}`;

    // Send page_view to GA for route tracking
    pageview(path);
  }, [location.pathname, location.search]);
}
